import { useEffect, useState } from "react";
import { Lock, BellRing, Bell } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const pad = (n) => String(n).padStart(2, "0");

function RemindButton({ round, reload }) {
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/vault/remind");
      toast.success(data.reminded ? "Wir erinnern dich, sobald der Tresor öffnet ⏰" : "Erinnerung entfernt");
      await reload();
    } catch (e) { toast.error(formatErr(e)); }
    finally { setBusy(false); }
  };
  const on = round.reminded;
  return (
    <div className="mt-3 space-y-1.5">
      <button onClick={toggle} disabled={busy} data-testid="vault-remind-btn" data-on={on}
        className={`inline-flex items-center gap-2 h-11 px-5 rounded-full font-extrabold transition-[transform,background-color] active:scale-95 disabled:opacity-60 ${on ? "bg-white/10 text-amber-200 ring-1 ring-amber-300/40" : "bg-gradient-to-br from-amber-300 to-amber-500 text-slate-900 vault-ok-ready"}`}>
        {on ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />} {on ? "Du wirst erinnert" : "Erinnere mich zur Öffnung"}
      </button>
      {round.waiting > 0 && <p className="text-xs font-bold text-amber-200/80" data-testid="vault-waiting">{round.waiting === 1 ? "1 Mitglied wartet" : `Schon ${round.waiting} Mitglieder warten`} auf den Tresor</p>}
    </div>
  );
}

export function VaultLocked({ at, onOpen, round, reload }) {
  const [left, setLeft] = useState(() => new Date(at) - Date.now());
  useEffect(() => {
    const iv = setInterval(() => {
      const l = new Date(at) - Date.now();
      setLeft(l);
      if (l <= 0) { clearInterval(iv); onOpen?.(); }
    }, 1000);
    return () => clearInterval(iv);
  }, [at, onOpen]);
  const s = Math.max(0, Math.floor(left / 1000));
  return (
    <div className="rounded-2xl p-4 text-center bg-amber-400/10 ring-1 ring-amber-400/30" data-testid="vault-locked">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-amber-300 flex items-center justify-center gap-1.5"><Lock className="w-3.5 h-3.5" /> Tresor verschlossen</p>
      <p className="font-display text-4xl font-black text-amber-300 tabular-nums mt-1 vault-pot" data-testid="vault-locked-countdown">{pad(Math.floor(s / 3600))}:{pad(Math.floor((s % 3600) / 60))}:{pad(s % 60)}</p>
      <p className="text-sm text-white/70 mt-1">Der neue Goldene Tresor öffnet um 9 Uhr – einmal am Tag gibt's einen neuen Code.</p>
      {round && <RemindButton round={round} reload={reload} />}
    </div>
  );
}
